import { useEffect, useMemo, useState } from 'react';
import { FetchStatuses } from '../../types/FetchStatus';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
const getObjectTypeNamesToIds = objectTypeDefinitions => {
  return objectTypeDefinitions.reduce((objectTypes, typeDef) => objectTypes.set(typeDef.fullyQualifiedName, {
    objectTypeId: typeDef.objectTypeId,
    pluralForm: typeDef.pluralForm,
    singularForm: typeDef.singularForm
  }), new Map());
};
export const fetchObjectTypeNamesToIds = () => {
  return getFrameworkDataSchemasClient().then(client => client.frameworkTypes.getObjects()).then(result => getObjectTypeNamesToIds(result));
};
export const useFetchObjectTypeNamesToIds = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState();
  useEffect(() => {
    fetchObjectTypeNamesToIds().then(result => setData(result)).catch(err => setError(err)).finally(() => setLoading(false));
  }, []);
  const formattedResult = useMemo(() => {
    if (loading) {
      return {
        status: FetchStatuses.LOADING,
        data: null
      };
    }
    if (error) {
      return {
        status: FetchStatuses.REJECTED,
        data: null,
        error
      };
    }
    if (data) {
      return {
        status: FetchStatuses.RESOLVED,
        data
      };
    }
    return {
      status: FetchStatuses.IDLE,
      data: null
    };
  }, [data, loading, error]);
  return formattedResult;
};